import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EditVideoBlock, TagAvailabilityResponse, VideoBlock, VideoBlockResponse } from 'src/app/models/block-video';
import { environment as env } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class BlockVideoService {
  private baseUrl = `${env.apiCerberoUrl}`;

  constructor(private http: HttpClient) { }

  getTagsCMS(): Promise<{id: number; slug: string; nombre: string }[]>{
    const url = 'https://filesstaticpulzo.s3.us-west-2.amazonaws.com/pulzo-lite/tags/tags_cms.json';

    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar Tags CMS');
        return res.json();
      })
      .then((data: {id: number; slug: string; nombre: string }[]) => {
        return data;
      });

  }

  saveVideoBlock(data: VideoBlock): Observable<VideoBlock>{
    return this.http.post<VideoBlock>(`${this.baseUrl}/request?event=guardar-bloque-video`, data);
  }

  getValidateTagAvailability(tag: string): Observable<TagAvailabilityResponse>{
    const params = new HttpParams()
    .set('event', 'validar-disponibilidad-tag')
    .set('tag', tag);

    return this.http.get<TagAvailabilityResponse>(`${this.baseUrl}/request?event=validar-disponibilidad-tag`, { params });
  }

  getSearchVideo(id:number): Observable<VideoBlockResponse>{
    return this.http.get<VideoBlockResponse>(`${this.baseUrl}/request?event=buscar-bloque-video-por-id&id=${id}`);
  }

  editVideoBlock(update: EditVideoBlock): Observable<EditVideoBlock>{
    return this.http.put<EditVideoBlock>(`${this.baseUrl}/request?event=editar-bloque-video`, update);
  }

}
